import { Grid, IconButton } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";
import Flex from "../../../../../components/Flex";
import OutlineCard from "../../../../../components/OutlineCard";
import Text from "../../../../../components/Text";
import {
  getXtenantId,
  replaceUnderScoreAddSpace,
} from "../../../../../utils/utils";
import useDisclosure from "../../../../../hooks/use-disclosure";
import UpsertFaxIntegrationDrower from "./UpsertFaxIntegrationDrower";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import { useGetFaxIntegration } from "../../../../../queries/communication/fax-integration/use-get-fax-integration";
import ProfileViewer from "../../../../../components/ProfileViewer";
import AddIcon from "@mui/icons-material/Add";
import MaskedPasswordText from "../../../../../components/app/MaskedPasswordText";

const FaxIntegrationDetails: React.FC = () => {
  const params = useParams();
  const addFaxIntegrationModalDisclosure = useDisclosure(false);
  const { data: faxIntegrationList } = useGetFaxIntegration({
    xtenantId: getXtenantId() ?? params?.providerGroupId ?? "",
  });
  return (
    <OutlineCard sx={{ height: "100%" }}>
      <UpsertFaxIntegrationDrower
        disClosureHost={addFaxIntegrationModalDisclosure}
        title="Fax Integration Details"
      />
      <Flex
        justifyContent="space-between"
        alignItems="center"
        marginBottom="20px"
      >
        <Text fontSize="16px" fontWeight="600">
          Fax Integration Details
        </Text>
        <IconButton onClick={() => addFaxIntegrationModalDisclosure.open()}>
          <AddIcon fontSize="small" />
        </IconButton>
      </Flex>

      <Grid container spacing={3}>
        {(faxIntegrationList?.data as unknown as any[])?.map(
          (faxIntegration) => (
            <Flex key={faxIntegration.uuid}>
              <OutlineCard
                sx={{ border: "0px", margin: "20px", position: "relative" }}
              >
                <IconButton
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                  }}
                  onClick={() =>
                    addFaxIntegrationModalDisclosure.open(faxIntegration)
                  }
                >
                  <ModeEditOutlineOutlinedIcon fontSize="small" />
                </IconButton>
                <ProfileViewer
                  data={{
                    Vendor:
                      replaceUnderScoreAddSpace(faxIntegration.vendor) || "",
                    UserName: faxIntegration.userName || "",
                    "Sender Email": faxIntegration.senderEmail || "",
                    "Fax Number": faxIntegration.faxNumber || "",
                    Password: {
                      custom: () => (
                        <MaskedPasswordText value={faxIntegration.password} />
                      ),
                    },
                    // uuid: faxIntegration.uuid || "",
                  }}
                  firstColW={4}
                  secondColW={8}
                  withoutColn
                />
              </OutlineCard>
            </Flex>
          )
        )}
      </Grid>
    </OutlineCard>
  );
};

export default FaxIntegrationDetails;
